import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M11.36 100.93H61.02C61.02 100.93 68.16 80.22 68.51 45.12C68.86 10.02 63.67 1.7699 63.67 1.7699H8.01999C8.01999 1.7699 -7.60001 52.8399 11.36 100.93Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
